export enum UserPermissions {
  ADD_CONNECTION = 'user.addConnection',
  DELETE_CONNECTION = 'user.deleteConnection',

  ACCESS_LEGACY_APP = 'user.accessLegacyApp',
}
